export const getLoggedInUserProfileDetail = (policies, user) => {
  // When user register for an account, the account is tied to a contract number.
  // We need to find the contract that they are tied to, then make sure they are the owner of that policy
  // Then extract that person object to display proper information.
  if (
    !Array.isArray(policies) ||
    policies?.length < 1 ||
    typeof user !== "object"
  ) {
    console.error("Please make sure all arg is valid");
    return undefined;
  }

  return policies
    .find((x) => x.contractID === user.contractId)
    ?.parties?.find(
      (x) =>
        (x.person?.partyTypeCode?.toLowerCase() === "ow" ||
          x.person?.partyTypeCode?.toLowerCase() === "jo") &&
        x.person?.taxId === user.identityNumber
    );
};
